export default __webpack_public_path__ + "static/media/logo.ead23d54.png";